export default "__VITE_ASSET__cd5fc27a__"